import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';
import React, { useEffect, useState } from 'react';
import { env } from '../../../env';
import { getMenuIcon } from '../../icons/menu';


const CredentialProxy = () => {

  const [agencyProxies, setAgencyProxies] = useState([]);
  const [proxyData, setProxyData] = useState({
    url: '',
    username: '',
    password: '',
    port: '',
    user_agent: '',
    id: ''
  });

  const handleProxyAdd = async () => {
    try {
      const data = await env.http
        .post('proxies', {
          url: (proxyData.url !== '') ? proxyData.url : null,
          port: (proxyData.port !== '') ? proxyData.port : null,
          username: (proxyData.username !== '') ? proxyData.username : null,
          password: (proxyData.password !== '') ? proxyData.password : null,
          user_agent: (proxyData.user_agent !== '') ? proxyData.user_agent : null
        })
        .then(response => response.data);
      setAgencyProxies(data);
      setProxyData({
        ...proxyData,
        url: '',
        username: '',
        password: '',
        port: '',
        user_agent: '',
        id: ''
      });

      env.alert('Успех', `Данные успешно сохранены`);
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не сохранились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const handleProxyUpdate = async () => {
    try {
      const data = await env.http
        .patch(`proxies`, {
          proxy_id: (proxyData.id !== '') ? proxyData.id : null,
          url: (proxyData.url !== '') ? proxyData.url : null,
          port: (proxyData.port !== '') ? proxyData.port : null,
          username: (proxyData.username !== '') ? proxyData.username : null,
          password: (proxyData.password !== '') ? proxyData.password : null,
          user_agent: (proxyData.user_agent !== '') ? proxyData.user_agent : null
        })
        .then(response => response.data);
      setAgencyProxies(data);
      setProxyData({
        ...proxyData,
        url: '',
        username: '',
        password: '',
        port: '',
        user_agent: '',
        id: ''
      });
      env.alert('Успех', `Данные успешно обновлены`);
    } catch (e) {
      console.log(e);
      env.alert(
        'Ошибка',
        `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
      );
    }
  };

  const handleSubmitButton = async () => {
    if (!proxyData.id) {
      await handleProxyAdd();
    } else {
      await handleProxyUpdate();
    }
  };

  const getAgencyProxies = () => {
    env.http.get('proxies/all').then(response => {
      setAgencyProxies(response.data);
    });
  };

  useEffect(() => {
    getAgencyProxies();
  }, []);


  return (
    <>
      <div className='profile-page__headline-title-change-proxy'>Список Прокси</div>
      <div>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ width: '65%', marginRight: '10px' }}>
            <h3>Url</h3>
            <input
              className='main-form__input main-form__input-full'
              placeholder='127.0.0.1'
              value={proxyData.url}
              required
              onChange={e => {
                setProxyData({ ...proxyData, url: e.target.value });
              }}
            />
          </div>
          <div style={{ width: '25%' }}>
            <h3>Port</h3>
            <input
              className='main-form__input main-form__input-full'
              value={proxyData.port}
              placeholder='8080'
              required
              onChange={e => {
                setProxyData({ ...proxyData, port: e.target.value });
              }}
            />
          </div>
        </div>
        <div style={{ width: '100%' }}>
          <h3>User-Agent</h3>
          <input
            className='main-form__input main-form__input-full'
            value={proxyData.user_agent}
            required
            onChange={e => {
              setProxyData({ ...proxyData, user_agent: e.target.value });
            }}
          />
        </div>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ width: '50%', marginRight: '10px' }}>
            <h3>Username</h3>
            <input
              className='main-form__input main-form__input-full'
              placeholder='username'
              value={proxyData.username}
              required
              onChange={e => {
                setProxyData({ ...proxyData, username: e.target.value });
              }}
            />
          </div>
          <div style={{ width: '50%' }}>
            <h3>Password</h3>
            <input
              className='main-form__input main-form__input-full'
              value={proxyData.password}
              placeholder='password'
              required
              onChange={e => {
                setProxyData({ ...proxyData, password: e.target.value });
              }}
            />
          </div>
        </div>

        <LaddaButton
          className='main-form__submit'
          type='submit'
          data-test-id='submitButton'
          data-color={(proxyData.id) ? 'blue' : '#eee'}
          data-size={XL}
          data-style={SLIDE_UP}
          data-spinner-size={30}
          data-spinner-color='#ddd'
          data-spinner-lines={12}
          onClick={handleSubmitButton}
        >
          {(proxyData.id) ? 'Обновить' : 'Добавить Proxy'}
        </LaddaButton>
        <br />
        <br />
        <div style={{
            maxHeight: '500px',
            overflowY: 'scroll'
        }}>
        {agencyProxies.map((proxyItem, index) => (
          <div key={index} style={{
            display: 'flex',
            alignItems: 'center',
            padding: '5px',
            borderBottom: "solid #ddd 1px",
          }}>
            <h3>{index} )</h3>
            <p
              style={{ minWidth: '120px', maxWidth: '120px', marginRight: 'auto', textAlign: 'center' }}
              key={index}
            >
              {proxyItem.url}
            </p>

            {(proxyData.id !== proxyItem.id) && (
              <>
                <button className='popup__btn edit-proxy'
                        onClick={() => setProxyData({
                          ...proxyData,
                          id: proxyItem.id,
                          url: proxyItem.url,
                          port: proxyItem.port,
                          username: proxyItem.username,
                          password: proxyItem.password,
                          user_agent: proxyItem.user_agent
                        })}>
                  {getMenuIcon('pencil')}
                </button>
              </>
            )}
            {(proxyData.id === proxyItem.id) && (
              <button
                className='popup__btn popup__btn_cancel js-popup-edit-cancel'
                onClick={() => setProxyData(
                  {
                    ...proxyData,
                    url: '',
                    username: '',
                    password: '',
                    port: '',
                    user_agent: '',
                    id: ''
                  }
                )}
              >
                {getMenuIcon('cancel')}
              </button>
            )}
          </div>
        ))}
      </div>
      </div>
    </>
  );
};

export default CredentialProxy;